import {
  useEffect,
  useRef,
} from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import getAuthService from '../getAuthService'
import setupIframeListener from './actions/setupIframeListener'

function AuthenticationFrame({
  client,
}) {
  const iframeRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (iframeRef && iframeRef.current) {
      iframeRef.current.addEventListener('load', () => {
        dispatch(setupIframeListener({
          iframeRef: () => iframeRef.current,
          client,
        }))
      })
    }
  }, [iframeRef, client])

  return (
    <iframe
      title="Infowijs Authentication"
      src={`${getAuthService(client)}/auth`}
      ref={iframeRef}
      style={{
        width: 0,
        height: 0,
      }}
    />
  )
}

AuthenticationFrame.propTypes = {
  client: PropTypes.string.isRequired,
}

export default AuthenticationFrame
